<template>
  <div>
    <v-row>
      <v-col sm="8" class="pa-0">
        <v-card tile class="pa-4">
          <v-form
              id="articleCreationForm"
              v-model="valid"
              lazy-validation
              ref="articleForm"
          >
            <v-text-field
                autocomplete="off"
                v-model="articleTitle"
                :rules="nameRules"
                required
                name="title"
                clearable
                class="rounded-0 mt-0"
                label="заголовок публикации"
            />
            <v-text-field
                autocomplete="off"
                v-model="articleLink"
                :rules="urlRules"
                name="link"
                clearable
                class="rounded-0"
                label="сслыка на публикацию"
            />
          </v-form>
        </v-card>
      </v-col>
    </v-row>

    <v-row class="mt-5">
      <v-col sm="8" class="pa-0">
        <v-card tile class="pa-4">
          <p class="pa-0 ma-0">Добавить теги(ключевые слова):</p>

          <v-combobox
              class="mt-0 pt-0"
              v-model="model"
              multiple
              persistent-hint
              hint="максимум 5 ключевых слов"
              chips
              append-icon=""
          >
          </v-combobox>

        </v-card>
      </v-col>
    </v-row>

    <v-row class="mt-5">
      <v-btn tile outlined text @click="checkMethod">
        Сохранить статью
      </v-btn>
    </v-row>
  </div>
</template>

<script>
import {createArticle, updateArticle} from "@/services/articleAPI";
import router from "@/router";

export default {
  name: "CreationForm",
  data() {
    return {
      articleTitle: "",
      articleLink: "",

      nameRules: [
        v => !!v || 'Поле не может быть пустым',
      ],

      urlRules: [(value) => !value || this.isURL(value) || "Неправильный URL"],

      valid: true,

      model: [],
    }
  },

  props: {
    isUpdating: {
      type: Boolean,
      required: false,
      default: false
    },

    articleToEdit: {
      type: Object,
      required: false,
    }
  },

  watch: {
    model(val) {
      if (val.length > 5) {
        this.$nextTick(() => this.model.pop())
      }
    },
  },

  methods: {
    isURL(str) {
      let url;

      try {
        url = new URL(str);
      } catch (_) {
        return false;
      }

      return url.protocol === "http:" || url.protocol === "https:";
    },

    async send () {
      try {
        if (!this.$refs.articleForm.validate()) throw new Error(`can't miss out on any field`)
        await createArticle(this.articleTitle, this.model, this.articleLink).then(data => console.log(data))
        await router.push('/articles')
      } catch (e) {
        console.log(e);
      }
    },

    async updateThisArticle () {
      try {
        if (!this.$refs.articleForm.validate()) throw new Error(`can't miss out on any field`)
        await updateArticle(this.articleToEdit.id ,this.articleTitle, this.model, this.articleLink).then(data => console.log(data))
        this.$emit('updateArticle', false)
      } catch (e) {
        console.log(e);
      }
    },

    checkMethod () {
      this.isUpdating
          ? this.updateThisArticle()
          : this.send()
    }

  },

  mounted() {
    if(this.isUpdating) {
      this.articleTitle = this.articleToEdit.title
      this.articleLink = this.articleToEdit.link
      this.model = this.articleToEdit.tags
    }
  },
}
</script>

<style scoped>

</style>